import { render } from "./AppSubNavigation.vue?vue&type=template&id=79c7c807&scoped=true&lang=pug"
import script from "./AppSubNavigation.vue?vue&type=script&lang=ts"
export * from "./AppSubNavigation.vue?vue&type=script&lang=ts"

import "./AppSubNavigation.vue?vue&type=style&index=0&id=79c7c807&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-79c7c807"

export default script